import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useSidebar } from "../ui/sidebar";
import { get } from "../../lib/api";

const StatisticsData = ({ game_id }) => {
  const { dates } = useSidebar();
  const [statistics, setStatistics] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    const fetchData = async () => {
      if (game_id === null) return;

      const data = await get(`/statistics?method=getGeneralStatistics&gameid=${game_id}&date=${selectedDate.toISOString().split("T")[0]}`);

      setStatistics(data);
    };

    fetchData();
  }, [selectedDate]); // Keeping the original dependency array as requested

  const changeDate = (date) => {
    let startDate = new Date(dates[0]);
    let endDate = new Date(dates[1]);
    if (date < startDate) {
      date = startDate;
    } else if (date > endDate) {
      date = endDate;
    }
    setSelectedDate(new Date(date));
  };

  return (
    <>
      <div className={"d-flex d-md-none date-container"}>
        <div className={"default_page_style"} style={{ color: "var(--dark)" }}>
          Choose a date:
        </div>
        <DatePicker className={"date-picker"} selected={selectedDate} onChange={(date) => changeDate(date)} dateFormat="dd-MM-yyyy" />
      </div>
      <table className={"table"}>
        <thead>
          <tr>
            <th>Statistic</th>
            <th style={{ justifyContent: "space-between", display: "flex" }}>
              Metric
              <div className={"d-none d-md-block"}>
                <DatePicker className={"date-picker"} selected={selectedDate} onChange={(date) => changeDate(date)} dateFormat="dd-MM-yyyy" />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(statistics).map(([key, value], index) => (
            <tr key={index}>
              <td>{key === "date" ? "Date" : key}</td>
              <td>
                <div style={{ justifyContent: "right", display: "flex", paddingRight: "1rem" }}>{value}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default StatisticsData;
